import { Link } from '@chakra-ui/react'

export const kindLabels = {label: 'Strings', ipfs_cid: 'Media'}
export const kindPaths = {label: '/', ipfs_cid: '/media'}
export const ipfsProxyUrl = (cid) => `/ipfs/${cid}.bin`

export const truncateRef = (ref, maxLen = 20) => ref?.length > maxLen ? `${ref.slice(0, maxLen - 3)}...` : ref

export const entryUrl = (entryId) => `/entry/${entryId}`
export const voteUrls = (entryId) => ({support: `/donate?chipIn=${entryId}`, oppose: `/donate?chipIn=${entryId}&oppose=1`})

export const buildVotesMap = (donations, keyField = 'donaRef') => {
  const map = new Map()
  for (const d of donations) {
    const key = d[keyField]
    if (!map.has(key)) map.set(key, {stance: d.supportOppose, entryId: d.entryId, amountUsd: d.contributedUsd})
  }
  return map
}

export const EntryLink = (/** @type {{[x: string]: any, entryId: any, donaRef: any, children?: any}} */ {entryId, donaRef, children, ...props}) => {
  return <Link href={entryUrl(entryId)} color="blue.600" {...props}>{children ?? truncateRef(donaRef)}</Link>
}
